import { gql } from '@apollo/client';

export const GET_FILTERED_INSPECTIONS = gql`
  query GetInspections($regionId: String!) {
    getFilteredInspections(regionId: $regionId) {
      allInspections {
        ...InspectionList
      }
    }
  }

  fragment InspectionList on Inspection {
    id
    apn
    inspectionTime
    submissionTime
    notes
    inspector
    issueSeverity
    attachments {
      id
      fileName
      link
    }
    propertyType
    inspectionType
    inspectionResult
    propertyAddress
    misc
    deckardid
  }
`;
